var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "my-container" },
    [
      _c(
        "div",
        { staticClass: "robot-header fx" },
        [
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-arrow-left", type: "text", size: "mini" },
              on: {
                click: function ($event) {
                  return _vm.dispatch("robot", "activeIndexChange", 0)
                },
              },
            },
            [_vm._v("返回")]
          ),
        ],
        1
      ),
      _c(
        "el-scrollbar",
        {
          ref: "scrollbar",
          staticClass: "gungun",
          staticStyle: {
            overflow: "hidden",
            height: "100%",
            "margin-top": "7px",
          },
          attrs: { "wrap-style": "overflow-x:hidden;" },
        },
        [
          _c(
            "el-table",
            {
              staticClass: "my-table",
              staticStyle: { width: "100%" },
              attrs: { left30: "", data: _vm.deepTaskList },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "keyword", label: "关键词" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.status == 1 || row.status == 3
                          ? _c("span", [
                              _vm._v(" " + _vm._s(row.keyword) + " "),
                            ])
                          : _c(
                              "el-link",
                              {
                                attrs: { underline: false, type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.clickKeyword(row.keyword)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(row.keyword))]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  align: "center",
                  label: "状态",
                  width: "95",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.status == 1
                          ? _c("span", { staticClass: "tasking" }, [
                              _vm._v("进行中"),
                              _c("i", {
                                staticClass: "iconfont icon-jinhangzhong",
                              }),
                            ])
                          : _c("span", [_vm._v("已完成")]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }